// Auto-generated from server/src/Jobs.Domain/Constants/PaymentMethodConstants.cs
// Do not modify manually - run 'npm run generate-constants' to regenerate

export const PaymentMethodConstants = {
  ManualOther: 'a1b2c3d4-0002-4000-8000-000000000001',
  ManualGreenSky: 'a1b2c3d4-0002-4000-8000-000000000002',
  ManualFinanced: 'a1b2c3d4-0002-4000-8000-000000000003',
  ManualAuthvia: 'a1b2c3d4-0002-4000-8000-000000000004',
  ManualCheck: 'a1b2c3d4-0002-4000-8000-00000000000e',
  ManualFoundationFinance: 'a1b2c3d4-0002-4000-8000-000000000011',
  ManualFinanceIt: 'a1b2c3d4-0002-4000-8000-000000000012',
  ManualSwipeSimpleCC: 'a1b2c3d4-0002-4000-8000-000000000013',
  ManualSquareCC: 'a1b2c3d4-0002-4000-8000-000000000014',
  ManualACH: 'a1b2c3d4-0002-4000-8000-000000000016',
  ManualChargeback: 'a1b2c3d4-0002-4000-8000-00000000001d',
  ManualOutOfPeriod: 'a1b2c3d4-0002-4000-8000-00000000001e',
  IntegrationAuthvia: 'a1b2c3d4-0002-4000-8000-000000000005',
  IntegrationGreenSky: 'a1b2c3d4-0002-4000-8000-000000000006',
  IntegrationAuthviaACH: 'a1b2c3d4-0002-4000-8000-00000000000f',
  IntegrationAuthviaCredit: 'a1b2c3d4-0002-4000-8000-000000000010',
  AcrFinancialAdjustmentCustomerSatisfaction: 'a1b2c3d4-0002-4000-8000-000000000007',
  AcrFinancialAdjustmentServiceFees: 'a1b2c3d4-0002-4000-8000-000000000008',
  AcrFinancialAdjustmentLegalSettlement: 'a1b2c3d4-0002-4000-8000-000000000009',
  AcrRefundViaCheck: 'a1b2c3d4-0002-4000-8000-00000000000a',
  AcrFinancialAdjustmentMissedChangeOrder: 'a1b2c3d4-0002-4000-8000-00000000000b',
  AcrFinancialAdjustmentOperationsDamage: 'a1b2c3d4-0002-4000-8000-00000000000c',
  AcrDepositForfeiture: 'a1b2c3d4-0002-4000-8000-00000000000d',
  AcrRefundViaCreditCard: 'a1b2c3d4-0002-4000-8000-000000000015',
  AcrRefundViaFinance: 'a1b2c3d4-0002-4000-8000-000000000017',
  AcrFinancialAdjustmentBalanceCompromise: 'a1b2c3d4-0002-4000-8000-000000000018',
  AcrFinancialAdjustmentAccountWriteOff: 'a1b2c3d4-0002-4000-8000-000000000019',
  AcrFinancialAdjustmentWriteOffRecovery: 'a1b2c3d4-0002-4000-8000-00000000001a',
  AcrFinancialAdjustmentCancelledWork: 'a1b2c3d4-0002-4000-8000-00000000001b',
  AcrRefundViaAuthvia: 'a1b2c3d4-0002-4000-8000-00000000001c'
} as const;
